import React, { useCallback, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import ScrollableSteps from '../../../components/ScrollableSteps/ScrollableSteps'
import { twMerge } from 'tailwind-merge'
import SectionWithTag from '../../../components/SectionWithTag'
import { useIsMobile } from '../../../utils/helpers'
import { Color } from '../../../utils/constants'

const id = 'page.partnerships.process'

const steps = [
    {
        id: `${id}.requirement-formulation`,
        slug: 'requirement-formulation',
    },
    {
        id: `${id}.starting-development`,
        slug: 'starting-development',
    },
    {
        id: `${id}.optimization`,
        slug: 'optimization',
    },
    {
        id: `${id}.production`,
        slug: 'production',
    },
]

const Process = () => {
    const [isVisible, setIsVisible] = useState(false)
    const [padding, setPadding] = useState<number | undefined>(undefined)
    const isMobile = useIsMobile()

    const calculatePadding = useCallback(
        (ref: HTMLDivElement) => {
            if (!isMobile) {
                setPadding(ref.getBoundingClientRect().right)
            } else {
                setPadding(undefined)
            }
        },
        [isMobile],
    )

    return (
        <div
            className={twMerge(
                'py-12 md:pt-30 relative transition duration-700',
                isVisible ? 'bg-sand' : 'bg-white',
            )}
        >
            <SectionWithTag
                tag={{ id: `${id}.tag` }}
                resizeCallback={calculatePadding}
                className='3xl:max-w-screen-2xl mx-auto'
            >
                <div className='flex md:flex-row flex-col items-center md:justify-between pt-9 md:pt-0 md:pb-20 md:gap-y-0'>
                    <div className='md:max-w-[600px]'>
                        <FormattedMessage id={id} tagName='h2' />
                    </div>
                    <div className='md:max-w-[410px]'>
                        {' '}
                        <FormattedMessage id={`${id}.description`} tagName='p' />
                    </div>
                </div>
            </SectionWithTag>
            <ScrollableSteps
                steps={steps}
                padding={padding}
                setIsVisible={setIsVisible}
                color={Color.SAND}
            />
        </div>
    )
}

export default Process
